import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import {
	Button,
	Dialog,
	DialogContent,
	Divider,
	Paper,
	TextField,
	Typography,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
	const [qrCode, setQrCode] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [pairingCode, setPairingCode] = useState("");
	const [requestingCode, setRequestingCode] = useState(false);

	useEffect(() => {
		const fetchSession = async () => {
			if (!whatsAppId) return;

			try {
				const { data } = await api.get(`/whatsapp/${whatsAppId}`);
				setQrCode(data.qrcode);
			} catch (err) {
				toastError(err);
			}
		};
		setPairingCode("");
		void fetchSession();
	}, [whatsAppId]);

	useEffect(() => {
		if (!whatsAppId) return;
		const socket = openSocket();

		socket.on("whatsappSession", data => {
			if (data.action !== "update" || data.session.id !== whatsAppId) return;

			setQrCode(data.session.qrcode);

			if (data.session.qrcode === "") {
				onClose();
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [whatsAppId, onClose]);

	const handleRequestPairingCode = async () => {
		setRequestingCode(true);
		try {
			const { data } = await api.post(
				`/whatsappsession/${whatsAppId}/pairing-code`,
				{ phoneNumber }
			);
			setPairingCode(data.code);
		} catch (err) {
			toastError(err);
		}
		setRequestingCode(false);
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
			<DialogContent>
				<Paper elevation={0}>
					<Typography color="primary" gutterBottom>
						{i18n.t("qrCode.message")}
					</Typography>
					{qrCode ? (
						<QRCode value={qrCode} size={256} />
					) : (
						<span>Waiting for QR Code</span>
					)}
				</Paper>
				<Divider style={{ margin: "16px 0" }} />
				<Paper elevation={0} style={{ maxWidth: 256 }}>
					<Typography color="primary" gutterBottom>
						{i18n.t("qrCode.pairing.title")}
					</Typography>
					{pairingCode ? (
						<>
							<Typography
								variant="h4"
								align="center"
								style={{ letterSpacing: 4, fontWeight: 700 }}
							>
								{pairingCode.length === 8
									? `${pairingCode.slice(0, 4)}-${pairingCode.slice(4)}`
									: pairingCode}
							</Typography>
							<Typography variant="body2" color="textSecondary">
								{i18n.t("qrCode.pairing.instructions")}
							</Typography>
						</>
					) : (
						<>
							<TextField
								fullWidth
								margin="dense"
								variant="outlined"
								label={i18n.t("qrCode.pairing.phoneNumber")}
								helperText={i18n.t("qrCode.pairing.phoneHelper")}
								value={phoneNumber}
								onChange={e => setPhoneNumber(e.target.value)}
							/>
							<Button
								fullWidth
								variant="contained"
								color="primary"
								disabled={requestingCode || phoneNumber.replace(/\D/g, "").length < 8}
								onClick={handleRequestPairingCode}
							>
								{i18n.t("qrCode.pairing.button")}
							</Button>
						</>
					)}
				</Paper>
			</DialogContent>
		</Dialog>
	);
};

export default React.memo(QrcodeModal);
